import {
  ADMIN_CR, CENTER_VIEWER_CR, NONE, REPORTER_CR, CAMPAIGN_RECIPIENT_CR, CAMPAIGN_MANAGER_CR, VAN_COMMITTEE_COORDINATOR_CR,
  VAN_CAMPAIGN_MANAGER_CR, RD_COMMITTEE_COORDINATOR_CR, STAND_IN_CR, WORKFLOW_TYPE,
} from '@/helpers/constants';
import crMatrix, { CR_PERMISSION_ACTIONS } from '@/helpers/crPermissions';
import { Authorization } from '@/types';

const useCRPermissionMatrix = (status: string, auth: Authorization) => {
  const getRealRole = (kindOfPermission: string, campaignRole: string) => {
    // TODO: Check if only with campaignRole === none return kindOfPermission
    if ([ADMIN_CR, NONE, REPORTER_CR, CENTER_VIEWER_CR, CAMPAIGN_RECIPIENT_CR, CAMPAIGN_MANAGER_CR, VAN_COMMITTEE_COORDINATOR_CR,
      VAN_CAMPAIGN_MANAGER_CR, RD_COMMITTEE_COORDINATOR_CR].includes(kindOfPermission) && campaignRole === NONE) {
      return kindOfPermission;
    }

    return campaignRole;
  };

  const isButtonDisabled = (feature: CR_PERMISSION_ACTIONS, workflowType?: typeof WORKFLOW_TYPE[keyof typeof WORKFLOW_TYPE]) => {

    if (!feature || !status || !auth) return true;

    const campaignRole = getRealRole(auth.kindOfPermission, auth.campaignRole);
    let authorizedURoles = crMatrix[feature]?.[status];

    if (workflowType) {
      authorizedURoles = crMatrix[feature]?.[workflowType]?.[status];
    }

    return !authorizedURoles?.includes(campaignRole);
  };

  const isReadOnly = () => auth?.readOnly;

  const asStandIn = auth?.asRepresentative && auth?.kindOfPermission === STAND_IN_CR;

  return {
    isButtonDisabled,
    isReadOnly,
    asStandIn,
  };
};

export default useCRPermissionMatrix;
